// recaptcha.interceptor.ts
import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { RecaptchaService, RecaptchaType  } from "lib-shared";
import { from, switchMap } from "rxjs";

@Injectable()
export class RecaptchaInterceptor implements HttpInterceptor {
    private readonly transactionEndpoints = [
    'AddCreditValidated',
    'AddValidatedPaymentMethod',
    'CreatevalidatedSubscriber',
    "DoValidatedSimOrder",
    'DoValidatedReloadData',
    'recaptcha'
  ];

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const recaptchaService = this.injector.get(RecaptchaService);
    let rawAction = req.url.split('/').pop() || 'default';
    // 🔧 Sanitize the name of the stock
    const action = rawAction.replace(/[^A-Za-z/_]/g, '') || 'default';

    const recaptchaType = this.isTransactionEndpoint(req.url) 
    ? RecaptchaType.TRANSACTION 
    : RecaptchaType.GENERAL;
    
    // console.log("isTransactionEndpoint: ", this.isTransactionEndpoint(req.url) )
    // console.log("req.url: ", req.url.split('/').pop() )
    // console.log("recaptchaType: ", recaptchaType)

    return from(recaptchaService.executeNewRecaptcha(action || 'default', recaptchaType)).pipe(
      switchMap((recaptchaToken) => {
        // const headers = recaptchaType === RecaptchaType.TRANSACTION
          // ? req.headers.set('X-ReCaptcha-FraudPrevention-Token', recaptchaToken)
          // : req.headers.set('X-ReCaptcha-Token', recaptchaToken);
          const headers = req.headers.set('X-ReCaptcha-Token', recaptchaToken);
        const modifiedReq = req.clone({
          headers,
        });
        return next.handle(modifiedReq);
      })
    );
  }

  private isTransactionEndpoint(url: string): boolean {
    return this.transactionEndpoints.some(endpoint => 
      url.toLowerCase().includes(endpoint.toLowerCase())
    );
  }
}
